import { isProd } from '~constants'

export const gaBtnClick = (clickEvent: string, ctaLocation: string, ctaAction: string) => {
  if (typeof window !== 'undefined' && isProd) {
    window.dataLayer.push({ event: clickEvent, ctaLocation, ctaAction })
  } else {
    console.debug(`Sending ${clickEvent} at ${ctaLocation} on ${ctaAction}`)
  }
}
